import {
  createFrontendPlugin,
  PageBlueprint,
  fetchApiRef,
  discoveryApiRef,
  createApiFactory,
  ApiBlueprint,
  identityApiRef,
} from '@backstage/frontend-plugin-api';
import { rootRouteRef } from './routes';
import { cheatSheetApiRef } from './types';
import { CheatSheetRestApi } from './apis';

// ── Route (→ app/routes) ────────────────────────────────
const cheatSheetPage = PageBlueprint.make({
  params: {
    path: '/cheat-sheet',
    routeRef: rootRouteRef,
    noHeader: true,
    loader: () => import('./components/HintsTable').then(m => <m.HintsTable />),
  },
});

const cheatSheetApi = ApiBlueprint.make({
  name: 'cheat-sheet-api',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: cheatSheetApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
          identityApi: identityApiRef,
        },
        factory: ({ discoveryApi, fetchApi, identityApi }) =>
          new CheatSheetRestApi({ discoveryApi, fetchApi, identityApi }),
      }),
    ),
});

export default createFrontendPlugin({
  info: {
    packageJson: () => import('../package.json'),
    manifest: () => import('../catalog-info.yaml'),
  },
  pluginId: 'neo4j-cheat-sheet',
  extensions: [cheatSheetApi, cheatSheetPage],
  routes: {
    root: rootRouteRef,
  },
});
